import React from 'react';
import '../styles/Miscellaneous.css';

const Miscellaneous = () => {
  return (
    <div className="miscellaneous-container" id="miscellaneous">
      <div className="miscellaneous-content">
      <h1 class="title is-2 section-title-misc">Miscellaneous</h1>
      <br/>
        <p>I love playing and watching basketball. I actually <a href="/garrytanchasecenter.jpg" target="_blank">met Garry Tan outside of Chase Center</a> when I was going to see a Warriors game.
        <br/>
        I've been caught up to and reading One Piece chapters week by week since December 2018. Here's my <a href="/onepiece848.jpeg" target="_blank">favorite cover page</a>.
        <br/>
        My favorite game is <a href="hgss_league.png" target="_blank">Pokémon Heart Gold</a>.  I chose Chikorita as the starter in that picture since I played the game with Cyndaquil and Totodile on other saves.
        </p>

      </div>
    </div>
  );
};

export default Miscellaneous; 